// This is a plain object for which we implement get/set functions rather than a class so that we can use it in redux stores

type TimedRecordValue<T> = {
  value: T;
  timestamp: number;
};

type TimedRecord<K extends keyof any, T> = Record<K, TimedRecordValue<T>>;

const DEFAULT_EXPIRY_MS = 1000;

const timedRecordGet = <K extends keyof any, T>(record: TimedRecord<K, T>, key: K, expiry: number = DEFAULT_EXPIRY_MS): T | null => {
  if (Date.now() - record[key].timestamp > expiry) {
    delete record[key];
    return undefined;
  }

  return record[key].value;
};

const timedRecordSet = <K extends keyof any, T>(record: TimedRecord<K, T>, key: K, value: T) => {
  record[key] = { value, timestamp: Date.now() };
};

export { TimedRecord, timedRecordGet, timedRecordSet };
